<template>
  <div class="products-page">
    <!-- 页面头部 -->
    <section class="page-hero">
      <div class="container">
        <h1 class="hero-title">产品中心</h1>
        <p class="hero-subtitle">专业的数字化解决方案，助力企业快速发展</p>
      </div>
    </section>

    <!-- 产品列表 -->
    <section class="products-content">
      <div class="container">
        <div class="product-item" v-for="product in products" :key="product.id">
          <div class="product-layout" :class="{ reverse: product.id % 2 === 0 }">
            <div class="product-info">
              <div class="product-header">
                <h2 class="product-title">{{ product.name }}</h2>
                <span class="product-tag">{{ product.tag }}</span>
              </div>
              <p class="product-description">{{ product.description }}</p>
              
              <div class="product-features">
                <h3>核心功能</h3>
                <ul class="features-list">
                  <li v-for="feature in product.features" :key="feature.title">
                    <div class="feature-icon">
                      <span v-html="feature.icon"></span>
                    </div>
                    <div class="feature-content">
                      <h4>{{ feature.title }}</h4>
                      <p>{{ feature.description }}</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="product-advantages">
                <h3>产品优势</h3>
                <div class="advantages-grid">
                  <div 
                    class="advantage-item" 
                    v-for="advantage in product.advantages" 
                    :key="advantage">
                    <span class="advantage-check">✓</span>
                    <span>{{ advantage }}</span>
                  </div>
                </div>
              </div>

              <div class="product-actions">
                <button class="btn-primary" @click="requestDemo(product)">
                  申请演示
                </button>
                <button class="btn-secondary" @click="downloadBrochure(product)">
                  下载资料
                </button>
              </div>
            </div>

            <div class="product-visual">
              <div class="product-image">
                <img :src="product.image" :alt="product.name">
                <!-- <img src="../assets/tg.png" alt="product.name"> -->
              </div>
              <div class="stats-grid">
                <div 
                  class="stat-item" 
                  v-for="stat in product.stats" 
                  :key="stat.label">
                  <div class="stat-number">{{ stat.value }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术架�?-->
    <section class="architecture-section">
      <div class="container">
        <h2 class="section-title">技术架构</h2>
        <p class="section-subtitle">先进的技术栈，确保系统稳定性和扩展性</p>
        
        <div class="tech-grid">
          <div class="tech-category" v-for="category in techStack" :key="category.name">
            <h3>{{ category.name }}</h3>
            <div class="tech-items">
              <div 
                class="tech-item" 
                v-for="tech in category.technologies" 
                :key="tech">
                {{ tech }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户案例 -->
    <section class="cases-section">
      <div class="container">
        <h2 class="section-title">客户案例</h2>
        <p class="section-subtitle">看看我们是如何帮助客户成功的</p>
        
        <div class="cases-grid">
          <div class="case-card" v-for="caseItem in cases" :key="caseItem.id">
            <div class="case-image">
              <img :src="caseItem.image" :alt="caseItem.company">
            </div>
            <div class="case-content">
              <h3 class="case-company">{{ caseItem.company }}</h3>
              <p class="case-industry">{{ caseItem.industry }}</p>
              <p class="case-description">{{ caseItem.description }}</p>
              <div class="case-results">
                <div 
                  class="result-item" 
                  v-for="result in caseItem.results" 
                  :key="result.metric">
                  <span class="result-value">{{ result.value }}</span>
                  <span class="result-metric">{{ result.metric }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <div class="contact-content">
          <h2>想了解更多产品信息？</h2>
          <p>我们的专业顾问将为您提供一对一的咨询服�?/p>
          <div class="contact-methods">
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <div>
                <h4>电话咨询</h4>
                <p>400-688-5235</p>
              </div>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📧</span>
              <div>
                <h4>邮件咨询</h4>
                <p>2294788755@qq.com</p>
              </div>
            </div>
            <!-- <div class="contact-item">
              <span class="contact-icon">💬</span>
              <div>
                <h4>在线咨询</h4>
                <p>点击右下角客服</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProductsPage',
  data() {
    return {
      products: [
        {
          id: 1,
          name: '本地生活团购SAAS系统',
          tag: '本地生活',
          description: '专为本地生活商家打造的小红书团购管理平台，帮助商家快速上架小红书团购店铺，通过智能化管理工具提升运营效率，实现获客增收。',
          image: "http://www.hnxueding.cn/img/tg.png",
          features: [
            {
              icon: '🏪',
              title: '快速店铺搭建',
              description: '一键同步商品信息，快速创建小红书团购店铺'
            },
            {
              icon: '📊',
              title: '智能数据分析',
              description: '全维度数据统计，帮助优化营销策略'
            },
            {
              icon: '🎯',
              title: '精准营销推广',
              description: '基于用户画像的精准营销工具'
            },
            {
              icon: '💰',
              title: '财务管理',
              description: '订单管理、财务结算、佣金分配一体化'
            }
          ],
          advantages: [
            '30秒快速开店',
            '智能客服支持',
            '多渠道推广',
            '数据安全保障',
            '7×24小时技术支持',
            '个性化定制'
          ],
          stats: [
            { value: '10000+', label: '服务商家' },
            { value: '500万', label: '月活用户' },
            { value: '99.9%', label: '系统稳定性' }
          ]
        },
        {
          id: 2,
          name: '微短剧平台发行解决方案',
          tag: '内容分发',
          description: '为承制方和平台方提供完整的微短剧发行平台解决方案，包含内容管理、版权保护、分发渠道管理、收益分析等全流程服务。',
          image: 'http://www.hnxueding.cn/img/dj.png',
          features: [
            {
              icon: '🎬',
              title: '内容管理系统',
              description: '支持多格式视频上传、编辑、审核流程'
            },
            {
              icon: '🔒',
              title: '版权保护机制',
              description: '数字水印、防盗版技术保护原创内容'
            },
            {
              icon: '📱',
              title: '多平台分发',
              description: '一键分发至多个短视频平台'
            },
            {
              icon: '💎',
              title: '收益优化',
              description: '智能推荐算法提升内容曝光和收益'
            }
          ],
          advantages: [
            '一站式内容管理',
            '自动化分发流程',
            '实时数据监控',
            '版权保护技术',
            '专业技术支持',
            '灵活定价策略'
          ],
          stats: [
            { value: '1000+', label: '内容创作者' },
            { value: '5000万', label: '累计播放量' },
            { value: '50+', label: '合作平台' }
          ]
        },
        {
          id: 3,
          name: 'IPTV C2内容分发解决方案',
          tag: '广电运营',
          description: '专业的IPTV内容分发与运营管理平台，帮助内容供应商快速将内容发行至运营商播控平台，并提供专业的代运营服务。',
          image: 'http://www.hnxueding.cn/img/c2.png',
          features: [
            {
              icon: '📡',
              title: '多渠道分发',
              description: '支持全国主要运营商播控平台接入'
            },
            {
              icon: '🔄',
              title: '自动化流程',
              description: '内容审核、编码、分发全流程自动化'
            },
            {
              icon: '📈',
              title: '运营数据分析',
              description: '用户观看行为分析和收益统计'
            },
            {
              icon: '🛠️',
              title: '代运营服务',
              description: '专业团队提供内容运营和推广服务'
            }
          ],
          advantages: [
            '全国运营商覆盖',
            '专业运营团队',
            '高清传输质量',
            '合规审核流程',
            '灵活结算方式',
            '7×24小时监控'
          ],
          stats: [
            { value: '200+', label: '运营商合作' },
            { value: '1亿', label: '终端用户' },
            { value: '99%', label: '内容合规率' }
          ]
        }
      ],
      techStack: [
        {
          name: '前端技术',
          technologies: ['Vue.js', 'React', 'TypeScript', 'Element UI', 'Ant Design']
        },
        {
          name: '后端技术',
          technologies: ['Spring Boot', 'Node.js', 'Python', 'Go', 'Java','PHP']
        },
        {
          name: '数据库',
          technologies: ['MySQL', 'Redis', 'MongoDB', 'Elasticsearch', 'ClickHouse']
        },
        {
          name: '云服务',
          technologies: ['阿里云', '腾讯云', 'AWS', 'Docker', 'Kubernetes']
        }
      ],
      cases: [
        {
          id: 1,
          company: '某知名餐饮连锁品牌',
          industry: '餐饮行业',
          description: '通过小红书团购SAAS系统，该品牌在3个月内实现了线上业务的快速增长，覆盖全国200+城市。',
          image: 'http://www.hnxueding.cn/img/tuangouanli.png',
          results: [
            { value: '300%', metric: '流量提升' },
            { value: '200%', metric: '订单增长' },
            { value: '150%', metric: '客户增长' }
          ]
        },
        {
          id: 2,
          company: '某头部影视制作公司',
          industry: '文娱行业',
          description: '使用微短剧平台发行系统后，该公司的内容分发效率提升了5倍，显著降低了运营成本。',
          image: 'http://www.hnxueding.cn/img/duanjuanli.png',
          results: [
            { value: '500%', metric: '分发效率' },
            { value: '60%', metric: '成本降低' },
            { value: '10倍', metric: '内容产量' }
          ]
        },
        {
          id: 3,
          company: '某大型内容供应商',
          industry: '广电行业',
          description: '通过IPTV C2分发系统，成功将优质内容推广至全国30+运营商平台，用户覆盖率大幅提升。',
          image: 'http://www.hnxueding.cn/img/c2anli.png',
          results: [
            { value: '50+', metric: '合作运营商' },
            { value: '500万', metric: '用户覆盖' },
            { value: '400%', metric: '收益增长' }
          ]
        }
      ]
    }
  },
  methods: {
    requestDemo(product) {
      alert(`申请 ${product.name} 演示，我们的销售顾问将在24小时内联系您`)
    },
    downloadBrochure(product) {
      alert(`${product.name} 产品资料下载中...`)
    }
  }
}
</script>

<style scoped>
.products-page {
  padding-top: 70px;
  min-height: 100vh;
}

/* 页面头部 */
.page-hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 1.2rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  line-height: 1.6;
}

/* 产品内容 */
.products-content {
  padding: 80px 0;
}

.product-item {
  margin-bottom: 120px;
}

.product-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.product-layout.reverse {
  direction: rtl;
}

.product-layout.reverse > * {
  direction: ltr;
}

.product-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;
}

.product-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.product-tag {
  background: #3470ff;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.product-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 40px;
}

.product-features h3,
.product-advantages h3 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 25px;
}

.features-list {
  list-style: none;
  padding: 0;
  margin-bottom: 40px;
}

.features-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.features-list li:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 2rem;
  min-width: 40px;
}

.feature-content h4 {
  font-size: 1.1rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
}

.feature-content p {
  color: #666;
  line-height: 1.6;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 40px;
}

.advantage-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: #f0f9ff;
  border-radius: 10px;
  color: #2c3e50;
  font-weight: 500;
}

.advantage-check {
  color: #3470ff;
  font-weight: bold;
  font-size: 1.1rem;
}

.product-actions {
  display: flex;
  gap: 20px;
}

.btn-primary,
.btn-secondary {
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary {
  background: #3470ff;
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.3);
}

.btn-secondary {
  background: transparent;
  color: #3470ff;
  border: 2px solid #3470ff;
}

.btn-secondary:hover {
  background: #3470ff;
  color: white;
}

.product-visual {
  text-align: center;
}

.product-image img {
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: #3470ff;
  margin-bottom: 8px;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

/* 技术架�?*/
.architecture-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.tech-category {
  background: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.tech-category h3 {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
  text-align: center;
}

.tech-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tech-item {
  background: #f0f9ff;
  color: #3470ff;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* 客户案例 */
.cases-section {
  padding: 80px 0;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.case-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.case-image img {
  width: 100%;
  height: 250px;
  object-fit: fill;
}

.case-content {
  padding: 30px;
}

.case-company {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
}

.case-industry {
  color: #3470ff;
  font-weight: 500;
  margin-bottom: 15px;
}

.case-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.case-results {
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.result-item {
  display: flex;
  flex-direction: column;
}

.result-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #3470ff;
  margin-bottom: 5px;
}

.result-metric {
  color: #666;
  font-size: 0.9rem;
}

/* 联系我们 */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
}

.contact-content h2 {
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.contact-content p {
  font-size: 1.2rem;
  margin-bottom: 50px;
  opacity: 0.9;
}

.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  max-width: 800px;
  margin: 0 auto;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.contact-icon {
  font-size: 2.5rem;
}

.contact-item h4 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.contact-item p {
  opacity: 0.9;
  margin: 0;
}

/* 响应式设�?*/
@media (max-width: 768px) {
  .product-layout {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .product-layout.reverse {
    direction: ltr;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .product-title {
    font-size: 1.8rem;
  }
  
  .product-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .product-actions {
    flex-direction: column;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .contact-item {
    flex-direction: column;
    text-align: center;
  }
}
</style> 
 